/**
 * Motion variants for stroke outline path draw animation
 */
export const pathDraw = {
  initial: {
    opacity: 0,
    pathLength: 0,
  },
  animate: {
    opacity: 1,
    pathLength: 1,
    transition: {
      duration: 0.5,
      ease: "easeOut",
    },
  },
};

export const iconSize = { base: "icon.2xl", xl: "icon.3xl" };

export type MediaProps = {
  isActive: boolean;
};
